module.exports = __webpack_public_path__ + "img/metrics.6c06c3ee.svg";